<!-- 账户余额-->
<template>
  <div class="page" v-cloak>

    <van-nav-bar :border="false" left-arrow fixed title="在线充值" class="on_line_nav_bar" @click-left="onClickLeft" :style="'background: #ff5000; color:#FFFFFF;'"></van-nav-bar>

    <div class="header-b">
      <div class="header-c">
        <p class="title">当前余额(元)</p>
        <h3 class="price">{{balance.true_amt | numToCash}}</h3>
        <p class="tips">温馨提示：此处充值的实际金额也可以在商城消费</p>
      </div>
    </div>

    <h3 class="list-tips">请选择充值金额</h3>

    <div class="center-bander">
      <div :class="['center-bander-item',  ind == radio_active ? 'bc0':'bc1']" v-for="(im, ind) in configList" :key="ind" @click="onSetPrice(im,ind)">
        <p class="price"> {{im.recharge_amt | numToCash}}<span>元</span></p>
        <p class="give-price" v-if="im.remark">
          <!-- <span></span> -->
          ({{im.remark }})
          <!-- <span></span> -->
        </p>
      </div>
    </div>

    <!-- <div class="center-prodect-bander">
        <div class="center-prodect-bander-item">
          <p class="price">查看下方: 充值298赠送价值298元商品</p>
          <p class="l-r-tips">
            < 左右滑动查看更多产品 >
          </p>
        </div>
      </div> -->

    <div class="new-goods-center" v-if="newProductList.length > 0">
      <van-swipe class="new-goods-swipe" :show-indicators="false">
        <van-swipe-item v-for="(imtge, index) in newProductList" :key="index">
          <img-text-block :show-type="'column'" v-for="(item, index) in imtge" :product="item" :key="index"></img-text-block>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- <van-button type="primary" @click="goPayresult">确认充值</van-button> -->

    <h3 class="list-tips">充值说明</h3>

    <div class="foot-tips">
      <p>1、请选择一个额度充值，务必仔细核对。</p>
      <p>2、充值实时到账，后台不提供退款服务，可在商城中消费。</p>
      <!-- <p class="foot-xy">支付即同意 <span @click="goClause">《充值协议》</span></p> -->
    </div>

    <!-- <div class="img-text-row">
        <div class="row-goods-img">
          <img src="../../assets/index/index_icon10.png" alt="" />
  
          <div class="row-goods-info">
            <p class="row-goods-name"> 零钱抢购</p>
          </div>
        </div>
        <div class="row-goods-right"> 规则介绍 </div>
      </div> -->

    <!-- 支付弹窗 -->
    <van-popup v-model="isPayPop" position="bottom" round :style="{ height: '30%' }" @close="clickClose()">
      <div class="pop-pay-header">
        <h3>支付提示</h3>
        <p class="pop-pay-price"><span>¥</span> {{jsMathFloor(orderInfo.money)}}</p>
      </div>
      <div class="pop-pay-btn-block">
        <div class="pop-pay-btn btn-a" @click="LinshiTzhaun">确认支付</div>
      </div>

    </van-popup>
    <!-- 支付弹窗 end -->

  </div>
</template>
  
  <script type="text/babel">
import wx from "weixin-js-sdk";
import imgTextBlock from "@/components/img-text-block/img-text-block.vue";
export default {
  name: "onLine",
  components: { imgTextBlock },
  props: {},
  data() {
    return {
      balance: {
        total: 0, // 余额
        true_amt: 0, // 充值余额
      },

      radio_active: -1,
      pay_active: {},
      configList: [
        // {
        //   id: 1, //配置项id
        //   recharge_amt: "298.00", //充值金额
        //   gift_coin: "20.00", //赠送金额
        //   true_coin: "318.00", //到账金额
        //   remark: "298赠送20", //备注说明
        // },
      ],
      giftList: [
        // {
        //   title: "Baseus/倍思-一拖三数据线", //标题
        //   pic: "https://qiniu.zdyxjx.com/v3/pic/75374758ee3c4adcb8adb23dd0ab88df.jpg ", //图片
        //   price: 299.2, //价格
        // },
      ],

      newProductList: [],

      isPayPop: false, //支付弹窗
      orderInfo: {}, //支付弹窗
    };
  },
  watch: {
    // aa: {
    //   handler(newValue, oldValue) {
    //     console.log(newValue, oldValue);
    //   },
    //   deep: true, // 深度监听表单
    // },
  },
  created() {},
  mounted() {
    this.getInit();
  },
  methods: {
    getInit() {
      let _this = this;
      this.$toast.loading();
      _this.$post("/api/recharge_index").then((res) => {
        console.log(res.data, "充值页配置");
        if (res.data && res.data.code == 0) {
          _this.$toast.clear();
          _this.balance = res.data.data.balance;
          _this.configList = res.data.data.configList;

          // let result = [];
          // let dataList = res.data.data.giftList;
          // if (dataList.length <= 4) {
          //   _this.newProductList = [dataList];
          //   console.log(dataList, "dataList");
          // } else {
          //   for (var i = 0; i < dataList.length; i += 4) {
          //     result.push(dataList.slice(i, i + 4));
          //   }
          //   _this.newProductList = result;
          //   console.log(result, "result");
          // }
        }
      });
    },
    // 切换充值类型
    onSetPrice(im, ind) {
      let _this = this;
      console.log(im);
      _this.pay_active = im;
      _this.radio_active = ind;
      this.goPayresult();
    },
    // 支付下单
    goPayresult(info) {
      let _this = this;
      // console.log(info)
      let data = {
        recharge_id: _this.pay_active.id, //充值选项id
        recharge_type: "unionpay", // 没有传空 unionpay
      };
      _this
        .$post("/api/recharge", data, data)
        .then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            console.log(res.data.data);

            _this.isPayPop = !_this.isPayPop; //支付方式弹窗
            _this.orderInfo = res.data.data;
          } else {
            _this.$toast.fail(res.data.message);
          }
        })
        .catch((err) => {
          //console.log(err.data)
        });
    },
    LinshiTzhaun() {
      window.location.href = this.orderInfo.pay;
    },

    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    goClause() {
      this.$router.push({ name: "on-line-recharge-clause", query: {} });
    },
    jsMathFloor(e) {
      let a = Math.floor(e * 100) / 100;
      return a;
    },
  },
};
</script>
  <style lang="scss">
.on_line_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
</style>
  
  <style lang="scss" scoped>
.page {
  //   height: 100%;
  width: 100%;
  padding: 0 0 50px 0;
  background-color: #f7f7f7;
  .header-b {
    height: 184px;
    width: 100%;
    background-image: url("../../assets/onLine/online_1.png");
    background-repeat: no-repeat;
    background-size: 100% 130px;
    // background-color: #000;
    padding: 50px 25px 0;

    .header-c {
      height: 130px;
      background: #ffffff;
      border-radius: 10px;
      padding: 15px;
      text-align: left;

      .title {
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .price {
        margin-top: 15px;
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        font-weight: bold;
      }
      .tips {
        margin-top: 15px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: #999999;
      }
    }
  }
  //
  .list-tips {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;

    text-align: left;
    padding: 10px 15px 0;
    overflow: hidden;

    span {
      float: right;
      padding: 5px 10px;
      background: linear-gradient(90deg, #ff5000 0%, #53a0fa 100%);
      border-radius: 10px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .list-tips_n {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;

    padding: 10px 15px 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      padding: 5px 10px;
      background: linear-gradient(90deg, #ff5000 0%, #53a0fa 100%);
      border-radius: 10px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .center-prodect-bander {
    padding: 15px 0 0;
    // background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;
    .center-prodect-bander-item {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid #f9f9f9;
      background: #ff5000;

      border-radius: 12px;
      text-align: center;
      padding: 15px;
      .price {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        span {
          font-size: 12px;
        }
      }
      .give-price {
        margin-top: 5px;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;

        span {
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
        }
      }

      .l-r-tips {
        color: #e8fa4c;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        margin-top: 5px;
      }
    }
  }

  //
  .center-bander {
    padding: 15px 0 0;
    // background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;

    .center-bander-item {
      box-sizing: border-box;
      width: 45%;
      margin: 0 8px 15px;
      border: 1px solid #f9f9f9;

      border-radius: 12px;
      text-align: center;
      padding: 15px;
      .price {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ff5000;
        span {
          font-size: 12px;
        }
      }
      .give-price {
        margin-top: 5px;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #f22b2b;

        span {
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #999999;
        }
      }
    }

    .bc0 {
      background: #ff5000;
      .price {
        color: #ffffff !important;
      }

      .give-price {
        color: #ffffff !important;
        span {
          color: #ffffff !important;
        }
      }
    }
    .bc1 {
      background: #ffffff;
    }
  }

  .list {
    padding: 0 15px 30px;
  }
}

.new-goods-center {
  padding: 0 10px 15px;
  //   background-color: green;
  .new-goods-swipe {
    height: 100%;
    width: 100%;
    .van-swipe-item {
      display: flex;
      flex-wrap: wrap;
    }
  }
}

// 底部提示

.foot-tips {
  padding: 15px;
  text-align: left;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;

  .foot-xy {
    margin-top: 30px;
    text-align: center;
    span {
      color: #ff5000;
    }
  }
}

// 横向
.img-text-row {
  margin: 15px;
  padding: 15px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .row-goods-img {
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 24px;
      height: 100%;
    }

    .row-goods-info {
      margin-left: 15px;
      padding: 5px 0;
      text-align: left;
      //  background-color: paleturquoise;

      .row-goods-name {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }
  }
  .row-goods-right {
    display: inline-block;
    padding: 5px 10px;
    background: rgba(234, 234, 234, 0.6);
    border-radius: 10px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
  }
}

.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}

// 支付弹窗
.pop-pay-header {
  h3 {
    margin-top: 10px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 30px;
    color: #2a2e43;
    letter-spacing: 1px;
  }
  .pop-pay-price {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 41px;
    color: #ff5000;
    letter-spacing: 1px;
    span {
      font-size: 12px;
    }
  }
  .pop-pay-time {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 25px;
    color: #666666;
    letter-spacing: 1px;
    display: flex;
    align-items: center;
    justify-content: center;

    .colon {
      display: inline-block;
      margin: 0 4px;
    }
    .block {
      display: inline-block;
      width: 22px;
      font-size: 12px;
      text-align: center;
      background-color: #eee;
      border-radius: 5px;
    }
  }
}
.pop-pay-center {
  padding: 20px 10px;
  background-color: #f9f9f9;
  .pop-pay-cell {
    height: 44px;
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    .pop-pay-left {
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 26px;
      color: #333333;
      letter-spacing: 1px;
    }
    .radio {
      width: 17px;
      height: 17px;
      .radio-icon {
        display: block;
        width: 100%;
      }
    }
  }
}
.pop-pay-btn-block {
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
  height: 49px;
  padding: 5px 0;
  background-color: #fff;
  // background-color: palegreen;
  .pop-pay-btn {
    background-color: #ff5000;
    font-size: 12px;
    border-radius: 20px;
    width: 80%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 21px;
    color: #ffffff;
  }
}
</style>
  